import React, { forwardRef } from "react";
import TextField from "ui/TextField/TextField";
import type { Props as TextFieldProps } from "ui/TextField/TextField";
import { cn } from "helpers/style";
import styles from "./Autocomplete.module.scss";

type Props = TextFieldProps & {
  suggestions?: Array<React.ReactElement>;
  className?: string;
  classNameTextField?: string;
  classNameTextFieldWrap?: string;
};

const Autocomplete = forwardRef<HTMLInputElement, Props>(
  (
    {
      suggestions = [],
      className,
      classNameTextField,
      classNameTextFieldWrap,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn([styles.autocomplete, className])}>
        <TextField
          {...props}
          ref={ref}
          className={cn([styles.autocompleteTextField, classNameTextField])}
          classNameWrap={classNameTextFieldWrap}
        />
        {suggestions && suggestions.length > 0 && (
          <ul
            className={styles.autocompleteSuggestions}
            onWheel={e => e.stopPropagation()}
          >
            {suggestions.map((s, index) => {
              return <li key={index}>{s}</li>;
            })}
          </ul>
        )}
      </div>
    );
  }
);

Autocomplete.displayName = "Autocomplete";

export default Autocomplete;
